<template>
    <div class="box" v-if="show">
        <van-popup v-model="show" :close-on-click-overlay="false">
            <van-loading type="spinner" color="#393939"/>
        </van-popup>
    </div>
</template>

<script>
    export default {
        name: "Loading",
        props:{
            show:{
                type:Boolean,
                default:false,
            }
        }
    }
</script>

<style scoped>
    .van-popup{
        background-color: transparent;
    }
</style>